import { startOfDay, endOfDay, isBefore, isAfter } from 'date-fns';
import { CALENDAR_TYPE } from '../../../../../../../../../config/calendar_type';
import { TYPE } from 'app/config/prescription_content';
import generateDates from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/generateDates';
import setTimePerShift from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/setTimePerShift';

import dateFormat from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/dateFormat';

const schedulePerDayPerShift = function (padPrescription, pad) {
  const { /*  instruction, */ padPrescriptionSuggestionScheduling } = padPrescription;

  const { PER_SHIFT } = CALENDAR_TYPE;
  //const cPadPrescription = await padPrescription.getByID(padPrescriptionId);

  const calendarType = PER_SHIFT;
  const { /* padId, */ description, type } = padPrescription;

  //let { startDate, endDate } = pad.getByID(padId);
  let { startDate, endDate } = pad;
  const padStartDate = startOfDay(startDate);
  const padEndDate = endOfDay(endDate);

  const { SUSPENDED } = TYPE;

  const isPadPrescriptionSuspended = type === SUSPENDED;

  if (isPadPrescriptionSuspended) return;

  const now = new Date();
  const startDateToday = startOfDay(now);

  /* const {
    period,
    continuousUse,
    once
    // frequencyTypeId,
    // frequencyAmount,
    // frequency,
    // timeStart,
    // timeEnd,
  } = pContent; */

  const {
    period,
    continuousUse,
    once
    // frequencyTypeId,
    // frequencyAmount,
    // frequency,
    // timeStart,
    // timeEnd,
  } = padPrescription;

  let dates = generateDates({
    period,
    continuousUse,
    once,
    startDate: startDateToday,
    endDate: padEndDate
  });

  dates = [...dates]
    // Removes date that are later than the padEndDate of Pad
    .filter(startDateTime => !isAfter(startOfDay(startDateTime), padEndDate))
    // Removes date that are before than the padStartDate of Pad
    .filter(startDateTime => !isBefore(startOfDay(startDateTime), padStartDate));

  // ***************************************************************************
  //                        SCHEDULE PRESCRIPTION CALENDAR
  // ***************************************************************************

  //const prescriptionContentId = pContent.id;
  const shifts = padPrescriptionSuggestionScheduling.map(
    suggestionScheduling => suggestionScheduling.shift
  );

  let listPerShiftCalendar = [];
  // eslint-disable-next-line
  for (const date of dates) {
    // eslint-disable-next-line
    for (const shiftId of shifts) {
      const administrateDate = setTimePerShift(date, shiftId);

      const insert = {
        //prescriptionContentId,
        calendarType,
        administrateDate,
        shiftId,
        // administrateVisitationId,
        // aplicationDate,
        // aplicationVisitationId,
        // digitalSignature,
        // latitude,
        // longitude,
        description
      };

      listPerShiftCalendar.push(insert);
    }
  }

  return dateFormat(listPerShiftCalendar);
};

export default schedulePerDayPerShift;
